module.exports = __webpack_public_path__ + "schemax-logo.543f34e.png";